/* eslint-disable no-nested-ternary */
import React, { useCallback, useState } from 'react'

import clsx from 'clsx'
import s from './CollectionsList.module.css'

function CollectionsList({ collections, isLoading, unitId, fetchCollections }) {
  const [inProgress, setInProgress] = useState(false)

  const handleAddToCollection = useCallback(
    async (collectionId) => {
      try {
        setInProgress(true)
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${collectionId}/add_listing`, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'PUT',
          body: JSON.stringify({ listing_id: unitId }),
        })

        const data = await response.json()
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        fetchCollections()
        setInProgress(false)
      }
    },
    [unitId]
  )

  const handleRemoveFromCollection = useCallback(
    async (collectionId) => {
      try {
        setInProgress(true)
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${collectionId}/remove_listing`, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'DELETE',
          body: JSON.stringify({ listing_id: unitId }),
        })

        const data = await response.json()
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        fetchCollections()
        setInProgress(false)
      }
    },
    [unitId]
  )

  return (
    <div className={s.root}>
      <div className={s.title}>Your Collections</div>

      {isLoading ? (
        <div className={s.inform}>Loading...</div>
      ) : collections.length > 0 ? (
        <div className={s.collections}>
          {collections?.map((collection) => {
            const isInCollection = collection?.listing_ids?.includes(unitId)
            return (
              <div key={collection.id} className={clsx(s.collection, isInCollection && s.active)}>
                <div className={s.collectionImage}>
                  <img className={s.collectionImageElem} src={collection.cover_photo_url} alt={collection.name} />
                </div>
                <div className={s.collectionName}>{collection.name}</div>

                <div className={s.controls}>
                  {isInCollection ? (
                    <button
                      disabled={inProgress}
                      type="button"
                      className={s.button}
                      onClick={() => handleRemoveFromCollection(collection.id)}
                    >
                      Remove
                    </button>
                  ) : (
                    <button
                      disabled={inProgress}
                      type="button"
                      className={s.button}
                      onClick={() => handleAddToCollection(collection.id)}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <div className={s.inform}>Your Collections are empty</div>
      )}
    </div>
  )
}

export default CollectionsList
